/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback, useState } from "react";

import { usePayjpClient } from "@/hooks/use-payjp-client";

import type * as FormModelType from "@/components/features/settings/payment-credit/model/type";

/**
 *
 * @description Payjp へ登録する際の必要な処理を作成する
 */
export const useRegistrationPayjp = (
	viewModel: FormModelType.PaymentCreditFormModel["ViewModel"],
	onSetViewModel: (value: FormModelType.PaymentCreditFormModel["ViewModel"]) => void,
) => {
	const { createPayjpToken } = usePayjpClient();

	const [targetElement, setTargetElement] = useState<HTMLElement>();
	const [cardHolderName, setCardHolderName] = useState("");
	const [cardEmail, setCardEmail] = useState("");
	const onChangeCardHolderName = useCallback((value: string) => {
		setCardHolderName(value);
	}, []);
	const onChangeCardEmail = useCallback((value: string) => {
		setCardEmail(value);
	}, []);

	/**
	 *
	 * @description Token を生成する際に、送信したい form の element を設定する
	 */
	const onSetTargetElement = useCallback((element: HTMLElement) => {
		setTargetElement(element);
	}, []);

	/**
	 *
	 * @description Payjp の element がエラーを持っているかどうかを ViewModel に設定する
	 */
	const onChangeHasPayjpValidation = useCallback(
		(hasError: boolean) => {
			onSetViewModel({ ...viewModel, hasPayjpValidation: hasError });
		},
		[onSetViewModel, viewModel],
	);

	/**
	 *
	 * @description Payjp へクレジットカード情報を送信し、Token を生成する
	 *
	 */
	const onCreatePayjpToken = useCallback(async () => {
		if (!targetElement || !cardHolderName || !cardEmail) return;

		const result = await createPayjpToken(targetElement, cardHolderName, cardEmail);
		return result;
	}, [createPayjpToken, targetElement, cardHolderName, cardEmail]);

	return {
		onSetTargetElement,
		onChangeCardHolderName,
		onChangeCardEmail,
		onChangeHasPayjpValidation,
		onCreatePayjpToken,
	};
};
